import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Paquete de Actividades Listas para Usar',
  value: '15',
  desc: 'Actividades de apertura, diagnóstico, investigación, trabajo de campo, laboratorio, análisis de casos reales de ETA, debates y extensión comunitaria. Clasificadas por tomo y listas para implementar.',
  benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.'
}, {
  id: '02',
  title: 'Paquete de Evaluaciones Completas',
  value: '15',
  desc: 'Evaluaciones para cada tomo: fundamentos, composición, microbiología, BPM, HACCP, análisis, contaminantes, conservación y una evaluación final integradora. Con distintos niveles de dificultad.',
  benefit: 'Nunca más pierdas tiempo de clase explicando qué significa cada concepto desde cero.'
}, {
  id: '03',
  title: 'Recetarios Técnicos para el Taller Escolar',
  value: '12',
  desc: 'Fichas técnicas completas de lácteos fermentados, conservas, encurtidos, productos deshidratados, panificación y cereales, bebidas fermentadas y no fermentadas. Pensadas para el taller escolar real, no para la industria.',
  benefit: 'Nunca más un silencio incómodo frente a una pregunta metodológica inesperada.'
}, {
  id: '04',
  title: 'Criterios de Corrección y Banco de Respuestas',
  value: '10',
  desc: 'Respuestas detalladas, puntajes desagregados y criterios claros para corregir evaluaciones y actividades complejas. Nunca más corrijas a ojo ni dudes sobre qué puntaje asignar.',
  benefit: 'Sin explicaciones extra. Lo ven, lo entienden y lo usan.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Incluidos sin costo extra
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-19">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-21">
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-26">
                <span className="text-gray-400 text-sm" data-id="element-27">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-28">USD {bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-29">→ GRATIS</span>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32">
          <p className="text-gray-300 mb-2" data-id="element-33">Valor total de los 4 bonos</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-34">USD 52,00</p>
          <p className="text-lg text-white mb-2" data-id="element-35">Tu precio hoy</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36">
            🎁 GRATIS
          </p>
          <p className="text-sm text-gold-light" data-id="element-37">
            Solo incluidos en esta oferta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}